"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _ = require("./..");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const SocialMediaNav = _ref => {
  let {
    facebookHandle,
    twitterHandle,
    linkedInHandle,
    instagramHandle,
    className
  } = _ref;
  const facebookUrl = "http://www.facebook.com/" + facebookHandle,
    twitterUrl = "http://www.twitter.com/" + twitterHandle,
    linkedInUrl = "http://www.linkedin.com/" + linkedInHandle,
    instagramUrl = "http://www.instagram.com/" + instagramHandle,
    facebookTitle = facebookHandle + " @ Facebook",
    twitterTitle = twitterHandle + " @ Twitter",
    linkedInTitle = linkedInHandle + " @ LinkedIn",
    instagramTitle = instagramHandle + " @ Instagram";
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("ul", {
    className: "social-icons social-icons-clean " + className,
    children: [facebookHandle ? /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
      className: "social-icons-facebook",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_.Link, {
        href: facebookUrl,
        target: "_blank",
        rel: "noreferrer",
        title: facebookTitle,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("i", {
          className: "fab fa-facebook-f"
        })
      })
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {}), twitterHandle ? /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
      className: "social-icons-twitter",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_.Link, {
        href: twitterUrl,
        target: "_blank",
        rel: "noreferrer",
        title: twitterTitle,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("i", {
          className: "fab fa-twitter"
        })
      })
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {}), linkedInHandle ? /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
      className: "social-icons-linkedin",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_.Link, {
        href: linkedInUrl,
        target: "_blank",
        rel: "noreferrer",
        title: linkedInTitle,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("i", {
          className: "fab fa-linkedin-in"
        })
      })
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {}), instagramHandle ? /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
      className: "social-icons-instagram",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_.Link, {
        href: instagramUrl,
        target: "_blank",
        rel: "noreferrer",
        title: instagramTitle,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("i", {
          className: "fab fa-instagram"
        })
      })
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {})]
  });
};
var _default = exports.default = SocialMediaNav;